<script setup lang="ts">
    import { ElConfigProvider } from "element-plus"
    import zhTw from "element-plus/es/locale/lang/zh-tw"
    import { onMounted } from "vue"

    import useVersionInfo from "./utils/useVersionInfo"

    zhTw.el.datepicker.confirm = "確認"

    const { createVersionConsole } = useVersionInfo()
    onMounted(() => console.info(...createVersionConsole(__VERSION_INFO__)))

    adSDKStg.init({
        publisherId: "f2fdc32e-e83f-4a33-9fc3-775770523be4",
        apiKey: "Zy62m61L-W3PVmyfuWjIcBnsXAoHNwQn47qvS2pOzaQ",
    })
</script>

<template>
    <el-config-provider :locale="zhTw">
        <router-view />
    </el-config-provider>
</template>
